module.exports = __webpack_public_path__ + "static/img/cocina_10.f061b547.jpeg";